<template lang="pug">
  ValidationObserver(v-slot="{ invalid, handleSubmit }" ref="validator")
    v-form.px-sm-0.px-md-10.pb-0.pb-sm-2.pb-md-4(@submit.prevent="handleSubmit(submitDataForm)")
      v-container(fluid)
        v-row
          v-col(cols="12")
            BaseTextField(rules="required" v-model="form.name", :label="translations.form.name")
        v-row(v-if="isDisabled")
          v-col(cols="12")
            p {{ translations.form.dateInfo }}
        v-row
          v-col(cols="12" sm="6" md="4")
            BaseDatePicker(rules="required" v-model="form.startdate.date", :label="translations.form.startdate.date", :disabled="isDisabled")
          v-col(cols="12" sm="6" md="4")
            BaseTimePicker(rules="required" v-model="form.startdate.time", :label="translations.form.startdate.time", :disabled="isDisabled")
        v-row
          v-col(cols="12" sm="6" md="4")
            BaseDatePicker(rules="required" v-model="form.enddate.date", :label="translations.form.enddate.date", :disabled="isDisabled")
          v-col(cols="12" sm="6" md="4")
            BaseTimePicker(rules="required" v-model="form.enddate.time", :label="translations.form.enddate.time", :disabled="isDisabled")
          v-col.pa-2.pa-md-6(cols="12")
            v-btn.float-right.big(:disabled="invalid"
              color="primary"
              type="submit"
              :loading="loadingEdit") {{ translations.buttons.edit }}

</template>

<script>

  export default {
    name: "ContestEdit",
    props: {
      clearForm: {
        type: Boolean,
        default: false
      },
      translations: {
        type: Object,
        default: function(){
          return {}
        }
      },
      contest: {
        type: Object,
        default: function(){
          return {}
        }
      }
    },
    data:() => ({
      form: {
        name: '',
        startdate: {
          date: null,
          time: null,
        },
        enddate: {
          date: null,
          time: null,
        },
      },
    }),
    computed: {
      loadingEdit() {
        return this.$store.state.statusCode.editContest.loading;
      },
      stateEdit() {
        return this.$store.state.statusCode.editContest.state;
      },
      isDisabled(){
        return !(this.contest.status.value == 'new' || this.contest.status.value == 'pending' || this.contest.status.value == 'open');
      },
    },
    watch: {
      clearForm: function(val){
        if (val){
          this.setFields();
          this.$refs.validator.reset();
        }
      },
      stateEdit: function(val){
        if (val == 200) {
          this.$emit('successEdit');
        }
      },
    },
    created(){
      this.setFields();
    },
    methods:{
      submitDataForm(){
        const formSend = {
          _id: this.contest._id,
          data: {
            name: this.form.name,
            start: this.getISOString(this.form.startdate),
            end: this.getISOString(this.form.enddate),
          }
        };
        this.$store.dispatch('editContest', formSend);
      },
      setFields(){
        const [startdate, starttime] = this.contest.startdate.split(' ');
        const [enddate, endtime] = this.contest.enddate.split(' ');
        this.form.name = this.contest.name;
        this.form.startdate.date = startdate;
        this.form.startdate.time = starttime;
        this.form.enddate.date = enddate;
        this.form.enddate.time = endtime;
      },
      getISOString(dateObj){
        let [day, month, year] = dateObj.date.split('/');
        month = month - 1;
        month = (month + '').length == 1 ? '0'+ month : month;
        return `${year}-${month}-${day}T${dateObj.time}:00:000Z`;
      },
    }
  }
</script>

<style lang="sass">
</style>